import { getHost } from '@kk-activity-factory/utils';
import { globalInstance } from '@kk-activity-factory/utils';

const HOST = getHost();
export function getActivityDetail() {
    const url = HOST + '/gamecard/v2/activityEnginePage';
    let p;
    if (window.getActivityDetail) {
        p = window.getActivityDetail;
        window.getActivityDetail = null;
    } else {
        let data = {};
        if (typeof window.getQuery('preview') !== 'undefined') {
            data = {
                id: window.activityEnginePageID,
                preview: window.getQuery('preview'),
            };
        } else {
            data = {
                id: window.activityEnginePageID,
            };
        }
        p = request({
            url: url,
            data: data,
        });
    }
    return p;
}

export function visitInfo() {
    const url = HOST + '/gamecard/v2/activityEnginePage/visitInfo';
    console.info(`请求${url}`);
    return request({
        url: url,
        data: {
            id: globalInstance.getRootStore().state.pageData.id,
        },
    });
}
